(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const mission = $('#mission');
  const drawer = $('#cart-drawer');
  let missionTimer, audio;

  const postJSON = async (url, body) => {
    const r = await fetch(`${url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    const d = await r.json();
    if (!r.ok) throw new Error(d.description || d.message);
    return d;
  };

  /* ---------- Cart drawer ---------- */
  async function refreshCart() {
    const r = await fetch(`${theme.root.replace(/\/$/, '')}/?sections=cart-drawer`);
    const html = (await r.json())['cart-drawer'];
    const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-drawer-inner]');
    if (!fresh) return;
    $('[data-drawer-inner]')?.replaceWith(fresh);
    const count = Number(fresh.dataset.count) || 0;
    $$('[data-cart-count]').forEach((c) => {
      c.textContent = count;
      c.hidden = count === 0;
      c.classList.remove('bump'); void c.offsetWidth; c.classList.add('bump');
    });
  }

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    $('.drawer__panel', drawer).focus();
  }

  function closeDrawer() {
    if (!drawer?.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }

  async function cartAction(fn) {
    drawer?.classList.add('is-busy');
    try { await fn(); await refreshCart(); } catch (e) { alert(e.message); }
    finally { drawer?.classList.remove('is-busy'); }
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-open-cart]') && drawer) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-drawer-close]')) { closeDrawer(); return; }
    const line = e.target.closest('[data-line]');
    if (line) cartAction(() => postJSON(theme.cartChangeUrl, { line: +line.dataset.line, quantity: +line.dataset.qty }));
  });

  document.addEventListener('change', (e) => {
    const t = e.target;
    if (t.matches('[data-protection]')) {
      const id = +t.dataset.protection;
      cartAction(() => t.checked
        ? postJSON(theme.cartAddUrl, { items: [{ id, quantity: 1 }] })
        : postJSON(theme.cartChangeUrl, { id: String(id), quantity: 0 }));
    }
    if (t.matches('[data-pack]')) document.getElementById(t.dataset.form)?.querySelector('[data-qty]')?.setAttribute('value', t.value);
    // ponytail: full reload on variant change; swap to Section Rendering API if it feels slow
    if (t.matches('[data-variant-select]')) location.href = `${t.dataset.url}?variant=${t.value}`;
  });

  /* ---------- Prima / dopo ---------- */
  document.addEventListener('input', (e) => {
    if (e.target.matches('[data-ba]')) e.target.closest('.ba').style.setProperty('--pos', `${e.target.value}%`);
  });

  /* ---------- Gallery ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-thumb]');
    if (!b) return;
    const img = b.closest('.product').querySelector('[data-main-image]');
    if (img && !img.src.endsWith(b.dataset.thumb)) {
      img.classList.add('is-swapping');
      setTimeout(() => {
        img.removeAttribute('srcset');
        img.src = b.dataset.thumb;
        img.decode?.().catch(() => {}).finally(() => img.classList.remove('is-swapping'));
      }, 200);
    }
    $$('[data-thumb]', b.parentElement).forEach((x) => x.toggleAttribute('aria-current', x === b));
  });

  /* ---------- Add to cart ---------- */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('.pform');
    if (!form) return;
    e.preventDefault();
    const buyNow = e.submitter?.hasAttribute('data-buy-now');
    const err = form.querySelector('.pform__error') || document.querySelector(`[data-error-for="${form.id}"]`);
    const btns = [...form.elements].filter((el) => el.type === 'submit');
    const wasDisabled = btns.map((b) => b.disabled);
    if (err) err.hidden = true;
    btns.forEach((b) => (b.disabled = true));
    try {
      const r = await fetch(`${theme.cartAddUrl}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const d = await r.json();
      if (!r.ok) throw new Error(d.description || d.message);
      if (buyNow) { location.href = '/checkout'; return; }
      await refreshCart();
      showMission(Number(form.elements.quantity?.value) || 1);
    } catch (x) {
      if (err) { err.textContent = x.message || err.dataset.fallback; err.hidden = false; }
    } finally {
      btns.forEach((b, i) => (b.disabled = wasDisabled[i]));
    }
  });

  /* ---------- Mission overlay ---------- */
  function showMission(qty) {
    if (!mission) { openDrawer(); return; }
    clearTimeout(missionTimer);
    closeDrawer();
    mission.classList.remove('is-out');
    mission.hidden = true; void mission.offsetWidth; mission.hidden = false; // restart animations
    const pts = mission.querySelector('[data-mission-points]');
    if (pts) countUp(pts, qty * 100);
    if (theme.sound) sting();
    missionTimer = setTimeout(() => {
      mission.classList.add('is-out');
      missionTimer = setTimeout(() => {
        mission.hidden = true;
        mission.classList.remove('is-out');
        if (theme.openDrawer) openDrawer();
      }, 600);
    }, 3200);
  }

  function countUp(el, to) {
    const start = performance.now() + 800, dur = 1200;
    el.textContent = '';
    const tick = (now) => {
      const p = Math.min(Math.max((now - start) / dur, 0), 1);
      el.textContent = p > 0 ? Math.round(to * (1 - (1 - p) ** 3)) : '';
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }

  // Original cinematic "hit": sub boom + filtered brass-like chord swell + shimmer
  let customSound;
  function sting() {
    if (theme.soundUrl) {
      customSound ||= new Audio(theme.soundUrl);
      customSound.currentTime = 0;
      customSound.play().catch(() => {});
      return;
    }
    try {
      audio ||= new (window.AudioContext || window.webkitAudioContext)();
      const t0 = audio.currentTime + 0.03;
      const out = audio.createGain();
      out.gain.value = 0.5;
      out.connect(audio.destination);

      const boom = audio.createOscillator(), bg = audio.createGain();
      boom.type = 'sine';
      boom.frequency.setValueAtTime(110, t0);
      boom.frequency.exponentialRampToValueAtTime(38, t0 + 0.6);
      bg.gain.setValueAtTime(0.9, t0);
      bg.gain.exponentialRampToValueAtTime(0.001, t0 + 1.1);
      boom.connect(bg).connect(out);
      boom.start(t0); boom.stop(t0 + 1.2);

      const lp = audio.createBiquadFilter();
      lp.type = 'lowpass';
      lp.frequency.setValueAtTime(400, t0 + 0.15);
      lp.frequency.exponentialRampToValueAtTime(3200, t0 + 0.6);
      lp.connect(out);
      for (const f of [146.83, 220, 293.66, 369.99, 440]) {
        for (const det of [-7, 7]) {
          const o = audio.createOscillator(), g = audio.createGain();
          o.type = 'sawtooth'; o.frequency.value = f; o.detune.value = det;
          g.gain.setValueAtTime(0, t0 + 0.15);
          g.gain.linearRampToValueAtTime(0.035, t0 + 0.35);
          g.gain.setValueAtTime(0.035, t0 + 1.4);
          g.gain.exponentialRampToValueAtTime(0.0001, t0 + 2.6);
          o.connect(g).connect(lp);
          o.start(t0 + 0.15); o.stop(t0 + 2.7);
        }
      }

      const sh = audio.createOscillator(), sg = audio.createGain();
      sh.type = 'triangle'; sh.frequency.value = 1760;
      sg.gain.setValueAtTime(0, t0 + 0.2);
      sg.gain.linearRampToValueAtTime(0.04, t0 + 0.25);
      sg.gain.exponentialRampToValueAtTime(0.0001, t0 + 1.2);
      sh.connect(sg).connect(out);
      sh.start(t0 + 0.2); sh.stop(t0 + 1.3);
    } catch {}
  }

  document.addEventListener('keydown', (e) => e.key === 'Escape' && closeDrawer());

  /* ---------- Sticky add-to-cart ---------- */
  const mainAtc = $('[data-main-atc]');
  const sticky = $('[data-sticky-atc]');
  if (mainAtc && sticky) {
    new IntersectionObserver(([en]) => {
      const on = !en.isIntersecting && en.boundingClientRect.top < 0;
      sticky.classList.toggle('is-on', on);
      sticky.setAttribute('aria-hidden', String(!on));
      sticky.querySelector('button').tabIndex = on ? 0 : -1;
    }).observe(mainAtc);
  }

  /* ---------- Pro motion layer ---------- */
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = matchMedia('(pointer: fine)').matches;
  const header = $('.header');
  const progress = $('.progress');
  const hero = $('[data-hero]');

  const esc = (c) => ({ '<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;' }[c] || c);
  // Split hero title into animated letters (keeps words together)
  $$('[data-split]').forEach((el) => {
    let i = 0;
    el.setAttribute('aria-label', el.textContent.trim());
    el.innerHTML = el.textContent.trim().split(/\s+/).map((w) =>
      `<span class="w" aria-hidden="true">${[...w].map((c) => `<span class="ch" style="--i:${i++}">${esc(c)}</span>`).join('')}</span>`
    ).join(' ');
  });

  // Hero depth layers
  $$('[data-depth]', hero || document.createElement('div')).forEach((el) => el.style.setProperty('--d', el.dataset.depth));

  let ticking = false;
  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      const y = scrollY;
      header?.classList.toggle('is-scrolled', y > 10);
      const max = document.documentElement.scrollHeight - innerHeight;
      progress?.style.setProperty('--p', max > 0 ? (y / max).toFixed(4) : 0);
      if (hero && !reduce && y < innerHeight * 1.2) hero.style.setProperty('--sy', (y / 10).toFixed(2));
      ticking = false;
    });
  };
  addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  if (hero && fine && !reduce) {
    hero.addEventListener('pointermove', (e) => {
      const r = hero.getBoundingClientRect();
      hero.style.setProperty('--mx', (((e.clientX - r.left) / r.width) - 0.5).toFixed(3));
      hero.style.setProperty('--my', (((e.clientY - r.top) / r.height) - 0.5).toFixed(3));
    });
    hero.addEventListener('pointerleave', () => { hero.style.setProperty('--mx', 0); hero.style.setProperty('--my', 0); });
  }

  // 3D tilt on cards (desktop only)
  if (fine && !reduce) {
    $$('.card, .pcard').forEach((c) => {
      c.dataset.tilt = '';
      c.addEventListener('pointermove', (e) => {
        const r = c.getBoundingClientRect();
        c.style.setProperty('--ry', `${(((e.clientX - r.left) / r.width) - 0.5) * 10}deg`);
        c.style.setProperty('--rx', `${(0.5 - ((e.clientY - r.top) / r.height)) * 10}deg`);
      });
      c.addEventListener('pointerleave', () => { c.style.removeProperty('--rx'); c.style.removeProperty('--ry'); });
    });
  }

  // Stagger index for reveal cascades
  $$('.cards, .steps, .specs, .reviews, .grid, .feat__list, .tbar, .stats').forEach((list) =>
    [...list.children].forEach((child, i) => child.style.setProperty('--i', i)));
  $$('.reveal').forEach((sec) => $$('.acc', sec).forEach((a, i) => a.style.setProperty('--i', i)));

  /* ---------- Countdowns (merchant-set end date) ---------- */
  $$('[data-countdown]').forEach((el) => {
    const end = new Date(el.dataset.countdown.trim().replace(' ', 'T')).getTime();
    if (!end || Number.isNaN(end)) return;
    const out = el.querySelector('[data-countdown-out]');
    const part = (k) => el.querySelector(`[data-cd="${k}"]`);
    const section = el.closest('[data-countdown-section]');
    const pad = (n) => String(n).padStart(2, '0');
    let id;
    const tick = () => {
      const left = Math.max(0, end - Date.now());
      if (!left) { el.hidden = true; if (section) section.hidden = true; clearInterval(id); return; }
      const d = Math.floor(left / 864e5), h = Math.floor(left / 36e5) % 24, m = Math.floor(left / 6e4) % 60, sec = Math.floor(left / 1e3) % 60;
      if (el.hasAttribute('data-clock')) {
        part('d').textContent = pad(d); part('h').textContent = pad(h); part('m').textContent = pad(m); part('s').textContent = pad(sec);
      } else if (out) {
        out.textContent = `${pad(Math.floor(left / 36e5))}:${pad(m)}:${pad(sec)}`; // total hours, no days
      }
      el.hidden = false;
    };
    id = setInterval(tick, 1000);
    tick();
  });

  /* ---------- Daily shipping cut-off (repeats every day, shop timezone) ---------- */
  $$('[data-cutoff]').forEach((el) => {
    const [H, M = 0] = el.dataset.cutoff.trim().split(':').map(Number);
    if (!Number.isInteger(H) || H < 0 || H > 23) return;
    const tz = el.dataset.tz || '+0000';
    const off = (tz[0] === '-' ? -1 : 1) * (Number(tz.slice(1, 3)) * 60 + Number(tz.slice(3, 5)));
    const skipWE = el.dataset.skipwe === 'true';
    const out = el.querySelector('[data-countdown-out]');
    const pad = (n) => String(n).padStart(2, '0');
    const shopDay = (t) => new Date(t + off * 6e4).getUTCDay();
    const nextCutoff = () => {
      const s = new Date(Date.now() + off * 6e4);
      let t = Date.UTC(s.getUTCFullYear(), s.getUTCMonth(), s.getUTCDate(), H, M) - off * 6e4;
      while (t <= Date.now() || (skipWE && [0, 6].includes(shopDay(t)))) t += 864e5;
      return t;
    };
    const tick = () => {
      const left = nextCutoff() - Date.now();
      out.textContent = `${pad(Math.floor(left / 36e5))}:${pad(Math.floor(left / 6e4) % 60)}:${pad(Math.floor(left / 1e3) % 60)}`;
      el.hidden = false;
    };
    tick();
    setInterval(tick, 1000);
  });

  /* ---------- Announcement rotation ---------- */
  $$('[data-rotate]').forEach((wrap) => {
    const slides = $$('.announce__slide', wrap);
    if (slides.length < 2 || reduce) return;
    let i = 0;
    setInterval(() => {
      slides[i].classList.remove('is-on');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-on');
    }, Math.max(3, Number(wrap.dataset.rotate) || 5) * 1000);
  });

  /* ---------- Back to top ---------- */
  const totop = $('[data-totop]');
  if (totop) {
    addEventListener('scroll', () => totop.classList.toggle('is-on', scrollY > innerHeight), { passive: true });
    totop.addEventListener('click', (e) => { e.preventDefault(); scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); });
  }

  /* ---------- Stats count-up ---------- */
  const countIO = new IntersectionObserver((entries) => entries.forEach((en) => {
    if (!en.isIntersecting) return;
    countIO.unobserve(en.target);
    const el = en.target, to = Number(el.dataset.count);
    if (!Number.isFinite(to) || reduce) return;
    const full = el.textContent, [pre, post] = full.split(String(to));
    const t0 = performance.now(), dur = 1400;
    const step = (now) => {
      const p = Math.min((now - t0) / dur, 1);
      el.textContent = `${pre ?? ''}${Math.round(to * (1 - (1 - p) ** 3))}${post ?? ''}`;
      if (p < 1) requestAnimationFrame(step); else el.textContent = full;
    };
    requestAnimationFrame(step);
  }), { threshold: 0.5 });
  $$('[data-count]').forEach((el) => countIO.observe(el));

  /* ---------- Scroll reveal ---------- */
  const io = new IntersectionObserver((entries) => entries.forEach((en) => {
    if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
  }), { threshold: 0.08, rootMargin: '0px 0px -8% 0px' });
  $$('.reveal').forEach((el) => io.observe(el));
})();
